/*
 * bundle-toggle.js — "Bundle & save" card selector for the product PDP.
 *
 * Loaded only on products that have a custom.bundle_group metafield (see main-product.liquid).
 * Each card is a real <a> to a separate product page (progressive enhancement: works with JS off).
 * With JS on, clicking a card swaps the buy box IN PLACE (price / Save / badges / ATC target /
 * what's-included), updates the URL via history.pushState, and (optionally) lazily swaps the
 * below-the-fold content sections via the Section Rendering API.
 *
 * Self-contained on purpose: it re-queries the same stable DOM hooks the theme's inline product
 * script uses, rather than depending on that script's per-product `variants[]` (which is baked for
 * the hero product and would be stale after switching products). It mirrors the class toggles in
 * main-product.liquid's updateBadges() so behaviour matches the native variant swap.
 */
(function () {
  'use strict';

  var group = document.querySelector('[data-bundle-group]');
  if (!group) return;

  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-card]'));
  if (!cards.length) return;

  // Stable buy-box hooks (these live in the buy box, which is NOT swapped).
  var priceContainerEl = document.getElementById('productPriceContainerEl');
  var priceEls = document.querySelectorAll('[data-product-price]');          // main price + ATC price + sticky price
  var compareEls = document.querySelectorAll('[data-product-compare-price]'); // struck-through compare price
  var titleEl = document.getElementById('productTitle');
  var stockBadges = document.querySelectorAll('[data-stock-badges]');
  var shippingBadges = document.querySelectorAll('[data-shipping-badge]');
  var cartBtns = document.querySelectorAll('[data-product-btns]');           // ATC + sticky ATC containers
  var variantInputs = document.querySelectorAll('[data-variant-id-input]');  // #product-select + #quick-product-select
  var variantSelect = document.querySelector('[data-bundle-variant-select]');  // variant dropdown, when the bundle's products also have variants
  var variantRadios = document.querySelectorAll('[data-bundle-variant-radio]');  // same choice as radio cards (large or compact presentation)

  // The variant choice can be presented three ways (dropdown / cards / compact cards). Read and
  // write it through one pair of helpers so nothing below cares which is on the page.
  function currentOption() {
    if (variantSelect) return variantSelect.value;
    for (var i = 0; i < variantRadios.length; i++) if (variantRadios[i].checked) return variantRadios[i].value;
    return null;
  }
  function setOption(val) {
    if (variantSelect) { variantSelect.value = val; return; }
    for (var i = 0; i < variantRadios.length; i++) variantRadios[i].checked = (variantRadios[i].value === val);
  }
  // The DISPLAY label for the current option, which is not the same string as its value:
  // custom.variant_option_label can rename it. Both presentations already render that label,
  // so read it back off the control rather than duplicating it into another data attribute.
  function currentOptionLabel() {
    if (variantSelect) {
      var o = variantSelect.options[variantSelect.selectedIndex];
      return o ? o.textContent.trim() : '';
    }
    for (var i = 0; i < variantRadios.length; i++) {
      if (!variantRadios[i].checked) continue;
      var lbl = document.querySelector('[data-product-kit-label][for="' + variantRadios[i].id + '"]');
      var t = lbl && lbl.querySelector('.product__kit-selector-title');
      return t ? t.textContent.trim() : '';
    }
    return '';
  }
  var compareBlockEl = document.getElementById('compareBlockText');
  var variantNoteEl = document.querySelector('[data-variant-compare-note]');       // step 2 summary bar text
  var bundleNameEl = document.querySelector('[data-selected-bundle-name]');        // chosen kit, named beside the step 1 heading
  var variantNameEl = document.querySelector('[data-selected-variant-name]');      // chosen variant, named beside the step 2 heading
  var kitValueEl = document.querySelector('[data-kit-value]');                     // "($547 value)"
  var kitSavingEl = document.querySelector('[data-kit-saving]');                   // yellow "$48 Kit Savings" pill
  // TWO percent pills: the theme renders a desktop and a mobile stock-badge row, and the pill now
  // lives with the stock badges. querySelector would only ever update the first one.
  var kitPercentEls = document.querySelectorAll('[data-kit-percent]');             // black "19% off" pills
  var whatsIncluded = document.querySelector('#whatsIncludedAccordion .accordion__content-inner');
  var includesList = document.querySelector('#bundleIncludes [data-bundle-includes-list]'); // dynamic component links in "What's included"
  var availContainer = document.querySelector('[data-bundle-avail-container]');             // stock-state block (ships today / ships later) above Add-to-cart
  var shipsToday = group.getAttribute('data-ships-today') || '';
  var partialLabel = group.getAttribute('data-partial-label') || 'Partial Pre-Order';
  var preorderLabel = group.getAttribute('data-preorder-label') || '';

  // Per-card option-value -> variant map, emitted by main-product.liquid when the bundle's
  // products carry variants. Without it a card knows only its own default variant.
  function variantMap(card) {
    try { return JSON.parse(card.getAttribute('data-bundle-variants') || '{}'); } catch (e) { return {}; }
  }

  // The chosen option (e.g. "Eco Toilet") must survive a kit switch. If the newly selected kit
  // has no variant for it, fall back to that kit's first variant rather than adding nothing.
  function resolveVariant(card) {
    var map = variantMap(card);
    var want = currentOption();
    if (want && map[want]) return { key: want, v: map[want] };
    var keys = Object.keys(map);
    return keys.length ? { key: keys[0], v: map[keys[0]] } : null;
  }

  function setHtml(nodeList, html) {
    for (var i = 0; i < nodeList.length; i++) nodeList[i].innerHTML = html;
  }

  // Mirror of main-product.liquid updateBadges(): toggle available / pre-order / sold-out state.
  function setState(state) {
    var states = ['available', 'pre-order', 'sold-out'];
    states.forEach(function (s) {
      var on = s === state;
      for (var i = 0; i < cartBtns.length; i++) cartBtns[i].classList.toggle(s, on);
      for (var j = 0; j < stockBadges.length; j++) stockBadges[j].classList.toggle(s, on);
    });
  }

  // The pre-order pill is reused for both full and partial pre-order; only its label differs.
  // Sync BOTH the buy-box pill and the sticky quick-ATC badge so they match.
  function setPreorderPillText(txt) {
    var nodes = document.querySelectorAll('.product__stock-badge--pre-order, .product-quick-atc__badge--pre-order');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = txt;
  }

  function applyBadges(d) {
    var available = d.bundleAvailable === 'true';
    // Kits tell their price story with the value figure and the pills, not with a red price and a
    // struck compare-at. Suppressing the sale state here is what keeps a discounted kit black.
    // Non-kit products (the base toilet, accessories) keep the theme's normal markdown treatment.
    var sale = d.bundleSale === 'true' && d.bundleIsKit !== 'true';

    // price container compare state (red price + show struck-through compare)
    if (sale) {
      if (priceContainerEl) priceContainerEl.classList.add('product__pricing--compare');
      for (var i = 0; i < compareEls.length; i++) {
        compareEls[i].innerHTML = d.bundleCompare || '';
        compareEls[i].style.display = 'block';
      }
    } else {
      if (priceContainerEl) priceContainerEl.classList.remove('product__pricing--compare');
      for (var j = 0; j < compareEls.length; j++) compareEls[j].style.display = 'none';
    }

    // Shipping badge shows the computed headline, but a kit with a late part shows none at all.
    setHtml(shippingBadges, d.bundleShip || shipsToday);
    var noShip = d.bundleNoShip === 'true';
    for (var s = 0; s < stockBadges.length; s++) stockBadges[s].classList.toggle('no-ship', noShip);
    for (var c = 0; c < cartBtns.length; c++) cartBtns[c].classList.toggle('no-ship', noShip);
    if (!available) {
      setState('sold-out');
    } else if (d.bundlePartial === 'true') {
      // buyable, but a component ships later → "Partial Pre-Order" (reuses the pre-order pill)
      setPreorderPillText(partialLabel);
      setState('pre-order');
    } else if (d.bundlePreorder) {
      setPreorderPillText(preorderLabel);
      setState('pre-order');
    } else {
      setState('available');
    }
  }

  function swapBuyBox(card) {
    var d = card.dataset;
    var sel = resolveVariant(card);
    var v = sel ? sel.v : null;

    // Compose the title the same way the Liquid does: product title alone when the product has
    // only a default variant, otherwise product + variant. sel.key IS the variant title, since
    // data-bundle-variants is keyed by it.
    if (titleEl && d.bundleTitle) {
      var newTitle = d.bundleTitle;
      // Stepped pages name the variant in step 2, so the H1 stays the product name only. This
      // mirrors the Liquid, which drops the variant from `title` when show_steps is on.
      var stepped = group.getAttribute('data-bundle-stepped') === 'true';
      if (!stepped && d.bundleDefaultVariant !== 'true' && sel && sel.key) newTitle += ' ' + sel.key;
      titleEl.innerHTML = newTitle;
    }

    // Fade the price the same way the theme's variantChange() does.
    var priceHtml = (v && v.price) ? v.price : d.bundlePrice;
    if (priceContainerEl) priceContainerEl.classList.remove('active');
    setTimeout(function () { setHtml(priceEls, priceHtml); }, 250);
    setTimeout(function () { if (priceContainerEl) priceContainerEl.classList.add('active'); }, 300);

    var hasShip = v && typeof v.ship === 'string';
    applyBadges(v ? {
      bundleAvailable: v.available ? 'true' : 'false',
      bundleSale: v.sale ? 'true' : 'false',
      bundleIsKit: d.bundleIsKit,          // carried through: applyBadges suppresses the sale state for kits
      bundleCompare: v.compare,
      bundleShip: hasShip ? v.ship : d.bundleShip,
      bundlePartial: hasShip ? (v.partial ? 'true' : 'false') : d.bundlePartial,
      bundleNoShip: hasShip ? (v.noShip ? 'true' : 'false') : d.bundleNoShip,
      bundlePreorder: hasShip ? (v.preorder || '') : d.bundlePreorder
    } : d);

    swapAvail(card, v);

    // Point BOTH cart forms (#product-select + #quick-product-select) at the selected variant.
    for (var i = 0; i < variantInputs.length; i++) variantInputs[i].value = v ? v.id : d.bundleVariantId;

    // Reflect a fallback back into the dropdown, so the control never disagrees with the cart.
    if (sel && currentOption() !== sel.key) setOption(sel.key);

    // Step 2 bar text follows the chosen variant, so it can differ between them.
    if (variantNoteEl && v && typeof v.note === 'string') variantNoteEl.textContent = v.note;

    // Kit value + savings pill. Both strings are built in Liquid, per variant, so the money
    // formatting and the wording live in one place. Empty string means this product has no gap to
    // claim (the base toilet, or any kit not priced below its parts), so hide all three.
    //
    // Swapped inside the SAME 250ms timer as the price. .product__pricing fades to opacity 0 on
    // change, so doing it immediately would show the new value beside the old price for a beat.
    var kitValue = (v && v.kitValue) || '';
    var kitSaving = (v && v.kitSaving) || '';
    var kitPercent = (v && v.kitPercent) || '';
    var showKit = !!(kitValue && kitSaving);
    setTimeout(function () {
      if (kitValueEl) {
        kitValueEl.textContent = kitValue;
        kitValueEl.style.display = showKit ? '' : 'none';
      }
      if (kitSavingEl) {
        kitSavingEl.textContent = kitSaving;
        kitSavingEl.style.display = showKit ? '' : 'none';
      }
      // The percent pill has its own visibility: a discounted non-bundle has a percent but no
      // kit value, so it must not be tied to showKit. Both copies are updated.
      for (var p = 0; p < kitPercentEls.length; p++) {
        kitPercentEls[p].textContent = kitPercent;
        kitPercentEls[p].style.display = kitPercent ? '' : 'none';
      }
    }, 250);

    // Name the current choice next to each step heading. This runs for a kit switch AND for a
    // variant change, since onVariantChange() re-enters here with the current card.
    if (bundleNameEl && d.bundleTitle) bundleNameEl.textContent = d.bundleTitle;
    if (variantNameEl) {
      var optLabel = currentOptionLabel();
      if (optLabel) variantNameEl.textContent = optLabel;
    }

    // Compare-kits CTA text + What's Included
    var kitTextHtml = (v && v.kitText) || d.bundleKitText;
    if (compareBlockEl && kitTextHtml) compareBlockEl.innerHTML = kitTextHtml;
    var whatsIncludedHtml = (v && v.whatsIncluded) || d.bundleWhatsIncluded;
    if (whatsIncluded && typeof whatsIncludedHtml === 'string') whatsIncluded.innerHTML = whatsIncludedHtml;

    // Selected-card highlight (mirrors the native checked-radio border via [aria-current]).
    cards.forEach(function (c) { c.removeAttribute('aria-current'); c.removeAttribute('data-bundle-current'); });
    card.setAttribute('aria-current', 'page');
    card.setAttribute('data-bundle-current', '');

    return sel;
  }

  // Option 1: swap only the FIRST gallery image (main carousel + first thumbnail) to the
  // selected bundle's featured/first image. Carousel runs loop:false, so the first
  // non-duplicate slide is the real first image — no Swiper instance needed.
  function swapFirstImage(card) {
    var url = card.dataset.bundleImage;
    if (!url) return;
    var sel = '.swiper-slide:not(.swiper-slide-duplicate) img';
    [
      document.querySelector('#lightboxTrigger ' + sel),            // main carousel, slide 0
      document.querySelector('#productCarouselThumbnails ' + sel)   // thumbnail strip, thumb 0
    ].forEach(function (img) {
      if (!img) return;
      img.srcset = '';            // clear responsive srcset so the new src is used
      img.src = url;
    });
  }

  // Dynamic "What's included" component links — swap the linked list to the selected bundle's.
  // (Accordion is native <details>: it only toggles on <summary>, so injected content links need no guard.)
  function swapIncludes(card) {
    if (includesList) includesList.innerHTML = card.dataset.bundleIncludes || '';
  }

  function swapAvail(card, v) {
    if (!availContainer) return;
    if (v && typeof v.avail === 'string') { availContainer.innerHTML = v.avail; return; }
    if (typeof card.dataset.bundleAvail === 'string') availContainer.innerHTML = card.dataset.bundleAvail;
  }

  function selectCard(card, push) {
    if (!card) return;
    var sel = swapBuyBox(card);
    syncCompareForms();
    swapFirstImage(card);
    swapIncludes(card);
    if (push) {
      var id = (sel && sel.v.id) || card.dataset.bundleVariantId;
      var url = card.dataset.bundleUrl;
      if (id && url) {
        try {
          var u = new URL(url, location.href);
          u.searchParams.set('variant', id);
          url = u.pathname + u.search + u.hash;
        } catch (e) {}
      }
      try { history.pushState({ bundleHandle: card.dataset.bundleHandle }, '', url); } catch (e) {}
    }
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      // Let modifier/middle clicks open the real product page in a new tab (don't hijack).
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      selectCard(card, true);
    });
  });

  // The variant dropdown is owned here, not by the theme's inline changeSelect/variantChange:
  // that path resolves against a variants[] array baked for the hero product, which is stale
  // after an in-place kit switch and would throw. Re-running swapBuyBox re-resolves cleanly.
  // The Compare Kits cards each carry their own add-to-cart form, outside the buy box. Keep them
  // in step with the chosen option, or they silently post their product's FIRST variant.
  function syncCompareForms() {
    var opt = currentOption();
    if (!opt) return;
    var forms = document.querySelectorAll('form[data-compare-variants]');
    for (var i = 0; i < forms.length; i++) {
      var map;
      try { map = JSON.parse(forms[i].getAttribute('data-compare-variants') || '{}'); } catch (e) { continue; }
      var v = map[opt];
      if (!v) continue;                                  // this product has no such option; leave it alone
      var input = forms[i].querySelector('[data-compare-variant-input]');
      if (input) input.value = v.id;
      // Rewrite the whole label rather than a nested <span>: the button is display:flex, so a
      // whitespace text node between two children is dropped and the space disappears.
      var btn = forms[i].querySelector('[data-compare-atc]');
      if (btn) {
        var label = btn.getAttribute('data-compare-atc-label') || '';
        if (v.price) btn.textContent = label + ' ' + v.price;
        btn.disabled = !v.available;
      }
    }
  }

  function syncVariantInUrl(id) {
    if (!id) return;
    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', id);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function onVariantChange() {
    var card = document.querySelector('[data-bundle-card][data-bundle-current]') || cards[0];
    if (!card) return;
    var sel = swapBuyBox(card);
    syncCompareForms();
    syncVariantInUrl((sel && sel.v.id) || card.dataset.bundleVariantId);
  }
  if (variantSelect) variantSelect.addEventListener('change', onVariantChange);
  for (var vr = 0; vr < variantRadios.length; vr++) variantRadios[vr].addEventListener('change', onVariantChange);

  // Back/Forward: restore the product whose URL we're returning to.
  window.addEventListener('popstate', function (e) {
    var handle = e.state && e.state.bundleHandle;
    if (!handle) return;
    var card = document.querySelector('[data-bundle-card][data-bundle-handle="' + handle + '"]');
    if (card) selectCard(card, false);
  });

  // Seed history state for the initially-shown product so the first Back works.
  var current = document.querySelector('[data-bundle-card][data-bundle-current]') || cards[0];
  try { history.replaceState({ bundleHandle: current.dataset.bundleHandle }, '', location.href); } catch (e) {}
  syncCompareForms();
})();
